import React from 'react';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/autoplay';
import '../styles/swipercomponent.css'

const SwiperComponent = ({ events }) => {
  return (
    <Swiper
      modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
      spaceBetween={50}
      slidesPerView={1}
      navigation
      pagination={{ clickable: true }}
      scrollbar={{ draggable: true }}
      autoplay={{ delay: 10000 }}
    >
      {events.map((event) => (
        <SwiperSlide key={event.sys.id}>
          <div className="event-card">
 
            <div className="event-img-col">
              <img
                src={event.fields.image.fields.file.url}
                alt={event.fields.eventName}
                style={{ maxWidth: '100%', maxHeight: '320px', width: 'auto', height: 'auto', display: 'block', objectFit: 'contain' }}
              />
            </div>
 
            <div className="event-content-col">
              <div className="event-content-top">
                <span className="event-tag">Featured Event</span>
                <h3 className="event-title">{event.fields.eventName}</h3>
                <p className="event-desc">{event.fields.eventDescription}</p>
              </div>
 
              <div className="event-content-bottom">
                <div className="event-meta-row">
                  <span className="event-meta-pill">
                    📅&nbsp; {event.fields.date}
                  </span>
                  <span className="event-meta-pill">
                    🕐&nbsp; {event.fields.time}
                  </span>
                </div>
                <button className="event-cta">View event details →</button>
              </div>
            </div>
 
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default SwiperComponent;
